import React from 'react';
import { ReferenceField, TextField } from 'react-admin';

export default [
  <ReferenceField key="email" source="targetUser" reference="users" link="show" sortBy="targetUser.email">
    <TextField source="email" />
  </ReferenceField>,
];
